namespace AgerLMS.LMS {
    export interface GetOrderAddressesResponse extends Serenity.ServiceResponse {
        BillingAddress?: Common.Address;
        ShippingAddress?: Common.Address;
        UserPhone?: string;
        UserEmail?: string;
        UserTcNo?: string;
        CargoName?: string;
        CargoFirmCode?: string;
    }
}
